import { ActionsOf } from "../utils";
import * as actions from "../actions-declarations/a11yes";

export type A11yActions = typeof actions;

const defaultState = {
    a11yes: [] as any[],
    a11yesByProperty: [] as any[],
    countsDisabilityTypes: null as any[] | null
}

export default function reducer(
    state = defaultState,
    actions: ActionsOf<A11yActions>): typeof state {
    switch (actions.type) {
        case "FETCH_A11YES":
            return {
                ...state,
                a11yes: actions.payload
            };
        case "CLEAR_A11YES":
            return { ...state, a11yes: [] }
        case "DELETE_A11Y":
            return {
                ...state,
                a11yes: [...state.a11yes.slice(0, actions.payload),
                ...state.a11yes.slice(actions.payload + 1)
                ]
            }
        case "UPDATE_A11Y":
            let a11yes = state.a11yes.slice(0)
            a11yes[actions.payload.index] = actions.payload.response
            return {
                ...state,
                a11yes
            }
        case "CREATE_A11Y":
            return {
                ...state,
                a11yes: [...state.a11yes, actions.payload]
            }

        case "FETCH_COUNTS_DISABILITY_TYPES":
            return {
                ...state,
                countsDisabilityTypes: actions.payload
            };
        case "CLEAR_COUNTS_DISABILITY_TYPES":
            return {
                ...state,
                countsDisabilityTypes: null!
            };
        case "FETCH_A11YES_BY_PROPERTY":
            return {
                ...state,
                a11yesByProperty: actions.payload
            };
        case "CLEAR_A11YES_BY_PROPERTY":
            return {
                ...state,
                a11yesByProperty: []
            };
        default:
            return state;
    }
}
